<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('店铺.店铺名称')" prop="shopName">
                <a-input v-model="queryParam.shopName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('店铺.店铺名称')"
                         allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('店铺.店铺类型')" prop="shopType">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('店铺.店铺类型')" style="width: 100%" v-model="queryParam.shopType" allowClear>
                  <a-select-option :value="1">平台</a-select-option>
                  <a-select-option :value="2">商家</a-select-option>
                  <a-select-option :value="3">门店</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('店铺.店铺状态是否开启')" prop="isRecommend">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('店铺.店铺状态')" style="width: 100%" v-model="queryParam.shopState" allowClear>
                  <a-select-option :value="0">关闭</a-select-option>
                  <a-select-option :value="1">开启</a-select-option>
                  <a-select-option :value="2">审核中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                    :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>{{ $t('通用.按钮.查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon
                  type="redo"/>{{ $t('通用.按钮.重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl"/>
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
              <a-button type="primary" @click="handleAddShop()" v-hasPermi="['shop:shop:addsj']">
                <a-icon type="plus" />新增商家
              </a-button>
              <a-button type="primary" @click="handleAddStore()" v-hasPermi="['shop:shop:addmd']">
                <a-icon type="plus" />新增门店
              </a-button>
              <a-button type="default" @click="handleExpandAll">
                <a-icon type="down-circle" />展开全部
              </a-button>
              <a-button type="default" @click="handleCollapseAll">
                <a-icon type="right-circle" />折叠全部
              </a-button>
        <!--   <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['shop:shop:edit']">
       <a-icon type="edit" />{{$t('通用.按钮.修改')}}
     </a-button>
     <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['shop:shop:remove']">
       <a-icon type="delete" />{{$t('通用.按钮.删除')}}
     </a-button>
     <table-setting
       :style="{float: 'right'}"
       :table-size.sync="tableSize"
       v-model="columns"
       :refresh-loading="loading"
       @refresh="getList" />
       -->
   </div>
      <!-- 增加修改 -->
<!--      <create-form
        ref="createForm"
        @ok="getList"
      />-->
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="treeList"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :defaultExpandAllRows="defaultExpandAll"
        :expandedRowKeys="expandedRowKeys"
        :childrenColumnName="'children'"
        @expand="onExpand"
      >
        <span slot="shopCreateTime" slot-scope="text, record">
          {{ parseTime(record.shopCreateTime) }}
        </span>
        <span slot="shopEndTime" slot-scope="text, record">
          {{ parseTime(record.shopEndTime) }}
        </span>
        <template slot="shopLogo" slot-scope="text, record">
          <div>
            <img v-if="record.shopLogo" :src="record.shopLogo" style="width:60px;height:62px;"
                 @click="handleRecordPreview(record.shopLogo)" alt="none"/>
          </div>
        </template>

        <template slot="qrCode" slot-scope="text, record">
          <div>
            <img v-if="record.qrCode" :src="record.qrCode" style="width:60px;height:62px;"
                 @click="handleRecordPreview(record.qrCode)" alt="none"/>
          </div>
        </template>
        <template slot="shopBackground" slot-scope="text, record">
          <div>
            <img v-if="record.shopBackground" :src="record.shopBackground" style="width:60px;height:62px;"
                 @click="handleRecordPreview(record.shopBackground)" alt="none"/>
          </div>
        </template>
        <span slot="shopRecommend" slot-scope="text, record">
          <a-switch @change="(checked) => onShopRecommendChange(checked,record)" :checked-children="$t('通用.文本.是')"
                    :un-checked-children="$t('通用.文本.否')" :checked="record.shopRecommend"/>
        </span>

<!--        <span v-if="record.settleType==2" slot="isStudy" slot-scope="text, record">-->
        <span  slot="isStudy" slot-scope="text, record">
          <a-switch @change="(checked) => onStudyChange(checked,record)" :checked-children="$t('通用.文本.是')"
                    :un-checked-children="$t('通用.文本.否')" :checked="record.isStudy"/>
        </span>
        <span slot="settleType" slot-scope="text, record">
             {{ record.settleTypeName }}
        </span>
        <span slot="shopType" slot-scope="text, record">
             {{ record.shopTypeName }}
        </span>
        <span slot="shopStateName" slot-scope="text, record">
             {{ record.shopStateName }}
        </span>
        <span slot="openStatus" slot-scope="text, record">
                       <custom-dict-tag :options="customDict.AccountOpenStatusEnum" :value="record.openStatus"/>
        </span>
        <span slot="categoryId" slot-scope="text, record">
            {{ getCategoryNameById(record.categoryId) }}
          </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="recommendTime" slot-scope="text, record">
          {{ parseTime(record.recommendTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a  v-if="record.openStatus == '' ||  record.openStatus == '0' || record.openStatus == '-1'" @click="openShopAccount(record)">-->
<!--               <a-icon type="edit"/>{{ $t('开通钱包') }}-->
<!--          </a>-->
<!--            <a @click="tiaozhuan(record)" >-->
<!--             <a-icon type="edit" />{{$t('跳转智慧零售')}}-->
<!--          </a>-->
          <a v-if="record.shopState === 2" @click="handleAudit(record)" v-hasPermi="['shop:shop:shenhe']">
               <a-icon type="check-circle"/>{{ $t('审核') }}
          </a>
          <a-divider type="vertical" v-if="record.shopState === 2" v-hasPermi="['shop:shop:edit']"/>
          <a @click="handleUpdate(record, undefined)" v-hasPermi="['shop:shop:edit']">
               <a-icon type="edit"/>{{ $t('通用.按钮.修改') }}
          </a>
          <a-divider type="vertical" v-if="record.shopType === 3" v-hasPermi="['shop:shop:edit']"/>
          <a v-if="record.shopType === 3" @click="handleBindAnYu(record)" v-hasPermi="['shop:shop:edit']">
               <a-icon type="link"/>{{ $t('绑定安瑜') }}
          </a>
          <!--
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['shop:shop:edit']">
               <a-icon type="edit"/>{{ $t('通用.按钮.修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['shop:shop:remove']"/>
          <a @click="handleDelete(record)" v-hasPermi="['shop:shop:remove']">
               <a-icon type="delete"/>{{ $t('通用.按钮.删除') }}
          </a>-->
        </span>
      </a-table>
      <!-- 绑定安瑜 -->
      <a-modal
        title="绑定安瑜"
        :visible="bindAnYuVisible"
        :confirmLoading="bindAnYuSubmitLoading"
        okText="确定"
        cancelText="取消"
        @ok="handleBindAnYuOk"
        @cancel="handleBindAnYuCancel"
      >
        <a-form-model ref="bindAnYuFormModel" :model="bindAnYuForm" :rules="bindAnYuRules" :labelCol="{lg: 6, sm: 6}"
                       :wrapperCol="{lg: 16, sm: 16}">
          <a-form-model-item label="安瑜门店" prop="anyuShopId">
            <a-tree-select
              v-model="bindAnYuForm.anyuShopId"
              style="width: 100%"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="anyuOrgTree"
              :replace-fields="anyuOrgReplaceFields"
              tree-default-expand-all
              :show-search="true"
              tree-node-filter-prop="name"
              allow-clear
              placeholder="请选择安瑜门店"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageShop, tiaozhuan,listShop, delShop, updateShopRecommend,updateIsStudy,openShopAccount,auditShop,bindAnYu,listAnYuOrgTree} from '@/api/shop/shop'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import {tableMixin} from '@/store/table-mixin'
import {listShopCategory} from "@/api/shop/shopCategory";
import bus from "@/utils/bus";
import { handleTree } from "@/utils/ruoyi";

export default {
  name: 'Shop',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      treeList: [],
      categoryList: [{id: "0", categoryName: ''}],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 绑定安瑜弹窗
      bindAnYuVisible: false,
      bindAnYuSubmitLoading: false,
      // 安瑜机构层级树（含门店）
      anyuOrgTree: [],
      anyuOrgReplaceFields: {children: 'children', title: 'name', key: 'id', value: 'id'},
      bindAnYuForm: {
        id: undefined,
        anyuShopId: undefined
      },
      bindAnYuRules: {
        anyuShopId: [
          {required: true, message: '请选择安瑜门店', trigger: 'change'}
        ]
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 树形表格相关
      defaultExpandAll: false,
      expandedRowKeys: [],
      // 查询参数
      queryParam: {
        shopName: undefined,
        shopLogo: undefined,
        shopBackground: undefined,
        shopKeywords: undefined,
        shopQc: undefined,
        timeOfEntry: undefined,
        shopAreap: undefined,
        shopAreac: undefined,
        shopAreax: undefined,
        shopAddress: undefined,
        longitude: undefined,
        latitude: undefined,
        shopDescription: undefined,
        kfPhone: undefined,
        companyType: undefined,
        settleType: undefined,
        shopType: undefined,
        shopRecommend: undefined,
        isStudy: undefined,
        userId: undefined,
        categoryId: undefined,
        shopState: undefined,
        shopCloseInfo: undefined,
        shopCollect: undefined,
        attentionNum: undefined,
        shopAccount: undefined,
        settlementAccount: undefined,
        shopCreateTime: undefined,
        shopEndTime: undefined,
        goodsDescribeScore: undefined,
        shopDescribeScore: undefined,
        logisticsScore: undefined,
        shopScore: undefined,
        thatViews: undefined,
        kfAccount: undefined,
        alarmGoodsStock: undefined,
        alarmGoodsSkuStock: undefined,
        weatherBzj: undefined,
        moneyBzj: undefined,
        platformRatio: undefined,
        contactsName: undefined,
        contactsPhone: undefined,
        contactsEmail: undefined,
        contactsCardNo: undefined,
        contactsCardHand: undefined,
        contactsCardFace: undefined,
        contactsCardCountry: undefined,
        businessLicenceNumber: undefined,
        companyName: undefined,
        companyAreap: undefined,
        companyAreac: undefined,
        companyAreax: undefined,
        companyAddressDetail: undefined,
        socialCreditCode: undefined,
        authCertificate: undefined,
        businessSphere: undefined,
        businessLicenceNumberElectronic: undefined,
        bankCardNoType: undefined,
        settlementBankUserName: undefined,
        settlementBankAccountNumber: undefined,
        bankUserPhone: undefined,
        settlementBankAccountName: undefined,
        settlementBankName: undefined,
        settlementBankAddress: undefined,
        accountInstCity: undefined,
        accountInstProvince: undefined,
        trademarkCertificate: undefined,
        shopProtocol: undefined,
        businessLicense: undefined,
        auditStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('店铺.店铺名称'),
          dataIndex: 'shopName',
          ellipsis: true,
          align: 'left'
        },
        {
          title: '上级店铺',
          dataIndex: 'parentShopName',
          ellipsis: true,
          align: 'center',
          customRender: function (text, record) {
            return record.parentShopName || '-'
          }
        },
        {
          title: this.$t('店铺.店铺logo'),
          dataIndex: 'shopLogo',
          ellipsis: true,
          scopedSlots: {customRender: 'shopLogo'},
          align: 'center'
        },
        {
          title: '登录账号',
          dataIndex: 'loginAccount',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('店铺.店铺背景图'),
        //   dataIndex: 'shopBackground',
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'shopBackground'},
        //   align: 'center'
        // },


        {
          title: this.$t('法人电话'),
          dataIndex: 'contactsPhone',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('店铺邀请码'),
        //   dataIndex: 'qrCode',
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'qrCode'},
        //   align: 'center'
        // },
        // {
        //   title: this.$t('店铺.入驻时长'),
        //   dataIndex: 'duration',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('店铺.入驻类型'),
        //   dataIndex: 'settleType',
        //   scopedSlots: {customRender: 'settleType'},
        //   ellipsis: true,
        //   align: 'center'
        // },

        {
          title: this.$t('店铺.店铺类型'),
          dataIndex: 'shopType',
          ellipsis: true,
          align: 'center',
          customRender: function (v) {
            if (v == 1) {
              return "平台";
            }else if (v == 2){
              return '商家';
            }else if (v == 3){
              return '门店';
            }
          }
        },

        // {
        //   title: this.$t('店铺.是否推荐'),
        //   dataIndex: 'shopRecommend',
        //   // sorter: 1,
        //   ellipsis: true,
        //   sortDirections: ['descend', 'ascend'],
        //   scopedSlots: {customRender: 'shopRecommend'},
        //   align: 'center'
        // },
        // {
        //   title: this.$t('店铺.推荐时间'),
        //   dataIndex: 'recommendTime',
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'recommendTime'},
        //   align: 'center'
        // },
        // {
        //   title: this.$t('店铺.店铺分类'),
        //   dataIndex: 'categoryId',
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'categoryId'},
        //   align: 'center'
        // },
        // {
        //   title: this.$t('能否发布线下活动'),
        //   dataIndex: 'isStudy',
        //   sorter: 1,
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'isStudy'},
        //   align: 'center'
        // },
        // {
        //   title: this.$t('店铺.账户余额'),
        //   dataIndex: 'shopAccount',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('店铺.已结算金额'),
        //   dataIndex: 'settlementAccount',
        //   ellipsis: true,
        //   align: 'center'
        // },
           {
               title: this.$t('法人姓名'),
               dataIndex: 'contactsName',
                ellipsis: true,
                  align: 'center'
           },

        {
          title: this.$t('店铺.店铺状态'),
          dataIndex: 'shopState',
          ellipsis: true,
          scopedSlots: {customRender: 'shopStateName'},
          align: 'center'
        },
        // {
        //   title: this.$t('店铺.钱包开通状态'),
        //   dataIndex: 'openStatus',
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'openStatus'},
        //   align: 'center'
        // },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
    this.getCategoryList();
    /**编辑页面接收到更新的数据 */
    bus.$on('updateShopList',()=>{
      this.getList()
    })
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    moment,

    tiaozhuan( record){
      tiaozhuan({"shopId":record.id}).then( response=>{
        console.log(response)
        if(response.code=="20001"){
          window.open(response.data)
        }
      })
    },
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询店铺列表 */
    getList() {
      this.loading = true
      listShop(this.queryParam).then(response => {
        this.list = response.data
        this.total = response.data.length
        
        // 构建店铺ID到名称的映射
        const shopNameMap = {}
        this.list.forEach(item => {
          shopNameMap[item.id] = item.shopName
        })
        
        // 为每个店铺添加上级店铺名称
        this.list.forEach(item => {
          if (item.parentId && shopNameMap[item.parentId]) {
            item.parentShopName = shopNameMap[item.parentId]
          }
        })
        
        // 构建树形结构
        this.treeList = handleTree(this.list, 'id', 'parentId', 'children', 0)
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        shopName: undefined,
        shopLogo: undefined,
        shopBackground: undefined,
        shopKeywords: undefined,
        shopQc: undefined,
        timeOfEntry: undefined,
        shopAreap: undefined,
        shopAreac: undefined,
        shopAreax: undefined,
        shopAddress: undefined,
        longitude: undefined,
        latitude: undefined,
        shopDescription: undefined,
        kfPhone: undefined,
        companyType: undefined,
        settleType: undefined,
        shopType: undefined,
        shopRecommend: undefined,
        isStudy: undefined,
        userId: undefined,
        categoryId: undefined,
        shopState: undefined,
        shopCloseInfo: undefined,
        shopCollect: undefined,
        attentionNum: undefined,
        shopAccount: undefined,
        settlementAccount: undefined,
        shopCreateTime: undefined,
        shopEndTime: undefined,
        goodsDescribeScore: undefined,
        shopDescribeScore: undefined,
        logisticsScore: undefined,
        shopScore: undefined,
        thatViews: undefined,
        kfAccount: undefined,
        alarmGoodsStock: undefined,
        alarmGoodsSkuStock: undefined,
        weatherBzj: undefined,
        moneyBzj: undefined,
        platformRatio: undefined,
        contactsName: undefined,
        contactsPhone: undefined,
        contactsEmail: undefined,
        contactsCardNo: undefined,
        contactsCardHand: undefined,
        contactsCardFace: undefined,
        contactsCardCountry: undefined,
        businessLicenceNumber: undefined,
        companyName: undefined,
        companyAreap: undefined,
        companyAreac: undefined,
        companyAreax: undefined,
        companyAddressDetail: undefined,
        socialCreditCode: undefined,
        authCertificate: undefined,
        businessSphere: undefined,
        businessLicenceNumberElectronic: undefined,
        bankCardNoType: undefined,
        settlementBankUserName: undefined,
        settlementBankAccountNumber: undefined,
        bankUserPhone: undefined,
        settlementBankAccountName: undefined,
        settlementBankName: undefined,
        settlementBankAddress: undefined,
        accountInstCity: undefined,
        accountInstProvince: undefined,
        trademarkCertificate: undefined,
        shopProtocol: undefined,
        businessLicense: undefined,
        auditStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({"id": id}))
          return delShop(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    onShopRecommendChange(checked, record) {
      let data = {id: record.id, shopRecommend: checked}
      updateShopRecommend(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.修改成功'),
            3
          );
          this.$emit('ok')
          record.shopRecommend = checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    openShopAccount(record){
      let data = {id: record.id}
      openShopAccount(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.提交成功'),
            3
          );
          this.$emit('ok')
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    onStudyChange(checked, record){
      let data = {id: record.id, isStudy: checked}
      updateIsStudy(data).then(response => {
        if (response.success) {
          this.$message.success(
              this.$t('通用.文本.修改成功'),
              3
          );
          this.$emit('ok')
          record.isStudy = checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    /** 审核店铺 */
    handleAudit(record) {
      var that = this
      this.$confirm({
        title: '审核店铺',
        content: '请选择审核结果',
        okText: '通过',
        okType: 'primary',
        cancelText: '拒绝',
        onOk() {
          that.$confirm({
            title: '确认通过',
            content: '确认通过该店铺的审核吗?',
            onOk() {
              let data = {id: record.id, shopState: 1}
              auditShop(data).then(response => {
                if (response.success) {
                  that.$message.success('审核通过', 3)
                  that.getList()
                } else {
                  that.$message.error(response.msg || '审核失败', 3)
                }
              }).catch(error => {
                that.$message.error('审核失败', 3)
              })
            }
          })
        },
        onCancel() {
          that.$confirm({
            title: '拒绝审核',
            content: '请输入拒绝原因',
            okText: '确认拒绝',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
              let reason = ''
              const modal = that.$modal({
                title: '拒绝原因',
                content: (h) => h('div', [
                  h('a-textarea', {
                    props: {
                      placeholder: '请输入拒绝原因',
                      rows: 4,
                      value: reason
                    },
                    on: {
                      input: (e) => {
                        reason = e.target.value
                      }
                    }
                  })
                ]),
                onOk: () => {
                  if (!reason || reason.trim() === '') {
                    that.$message.warning('请输入拒绝原因', 2)
                    return false
                  }
                  let data = {id: record.id, shopState: 0, shopCloseInfo: reason}
                  auditShop(data).then(response => {
                    if (response.success) {
                      that.$message.success('审核已拒绝', 3)
                      that.getList()
                    } else {
                      that.$message.error(response.msg || '操作失败', 3)
                    }
                  }).catch(error => {
                    that.$message.error('操作失败', 3)
                  })
                }
              })
            }
          })
        }
      })
    },
    /*页面初始化时获取分类类别*/
    getCategoryList() {
      listShopCategory().then(response => {
        this.categoryList = response.data;
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.cateOptions = children
      })
    },
    /*根据总后台还是店铺初始化加载页面数据*/
    getColumns() {
      // v-hasPermi="['shop:shop:add']"
    },
    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },
    /** 编辑商品信息 **/
    handleUpdate(row) {
      this.$router.push({
        path: 'shopForm',
        query:
          {
            id: row.id
          }
      })
    },
    /** 绑定安瑜 **/
    handleBindAnYu(record) {
      this.bindAnYuForm = {
        id: record.id,
        anyuShopId: record.anyuShopId
      }
      this.bindAnYuVisible = true
      this.getAnYuOrgTree()
      this.$nextTick(() => {
        if (this.$refs.bindAnYuFormModel) {
          this.$refs.bindAnYuFormModel.clearValidate()
        }
      })
    },
    /** 获取安瑜机构层级树，机构节点不可选，只能选门店 **/
    getAnYuOrgTree() {
      listAnYuOrgTree().then(response => {
        this.anyuOrgTree = this.buildAnYuOrgTree(response.data)
      })
    },
    buildAnYuOrgTree(nodes) {
      return (nodes || []).map(node => {
        return {
          id: node.id,
          name: node.name,
          store: node.store,
          // 机构节点不可选，只能选门店
          disabled: !node.store,
          children: this.buildAnYuOrgTree(node.children)
        }
      })
    },
    handleBindAnYuCancel() {
      this.bindAnYuVisible = false
    },
    handleBindAnYuOk() {
      this.$refs.bindAnYuFormModel.validate(valid => {
        if (!valid) {
          return
        }
        this.bindAnYuSubmitLoading = true
        bindAnYu({
          id: this.bindAnYuForm.id,
          anyuShopId: this.bindAnYuForm.anyuShopId
        }).then(response => {
          this.bindAnYuSubmitLoading = false
          if (response.success) {
            this.$message.success('绑定成功', 3)
            this.bindAnYuVisible = false
            this.getList()
          } else {
            this.$message.error(response.msg || '绑定失败', 3)
          }
        }).catch(() => {
          this.bindAnYuSubmitLoading = false
        })
      })
    },
    handleAddShop() {
      this.$router.push({
        path: 'shopForm',
        query: {
          type: 2
        }
      })
    },
    handleAddStore() {
      this.$router.push({
        path: 'shopForm',
        query: {
          type: 3
        }
      })
    },
    /** 展开全部 */
    handleExpandAll() {
      this.expandedRowKeys = this.getAllExpandedKeys(this.treeList)
    },
    /** 折叠全部 */
    handleCollapseAll() {
      this.expandedRowKeys = []
    },
    /** 获取所有展开的key */
    getAllExpandedKeys(nodes) {
      const keys = []
      const traverse = (list) => {
        list.forEach(node => {
          if (node.children && node.children.length > 0) {
            keys.push(node.id)
            traverse(node.children)
          }
        })
      }
      traverse(nodes)
      return keys
    },
    /** 展开/折叠事件 */
    onExpand(expanded, record) {
      if (expanded) {
        this.expandedRowKeys.push(record.id)
      } else {
        this.expandedRowKeys = this.expandedRowKeys.filter(key => key !== record.id)
      }
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('shop/shop/export',
            ...that.queryParam
            , `店铺_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
